import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {

  private excludedRoutes: string[] = [
    '/index',
    '/contact' // Ajoutez ici les routes des composants à exclure
  ];

  private internalScripts: string[] = [
    "assets/index/js/slick.min.js",
      "assets/js/libs/jquery-3.1.1.min.js",
      "assets/js/loader.js",
      "assets/bootstrap/js/popper.min.js",
      "assets/bootstrap/js/bootstrap.min.js",
      "assets/plugins/fullcalendar/moment.min.js",
      "assets/plugins/calendar/pignose/moment.latest.min.js",
      "assets/plugins/calendar/pignose/pignose.calendar.js",
      "assets/js/ui-kit/notification/tympanus/modernizr.custom.js"
  ];

  private lateInternalScripts: string[] = [
      "assets/js/modules/modules-weather-and-calendar.js",
      "assets/plugins/fullcalendar/fullcalendar.min.js",
      "assets/plugins/fullcalendar/custom-fullcalendar.advance.js",
      "assets/js/ui-kit/ui-accordions.js",
      "assets/js/ui-kit/ui-tooltip-popovers.js",
      "assets/plugins/sweetalerts/sweetalert2.min.js",
      "assets/plugins/sweetalerts/custom-sweetalert.js",
      "assets/js/ui-kit/notification/iao-alert.jquery.js",
      "assets/js/ui-kit/notification/notify.js",
      "assets/js/ui-kit/notification/notification.js",
      "assets/js/ui-kit/notification/notify-metro.js",
      "assets/js/ui-kit/notification/tympanus/snap.svg-min.js",
      "assets/js/ui-kit/notification/tympanus/classie.js",
      "assets/js/ui-kit/notification/tympanus/notificationFx.js",
      "assets/js/ui-kit/ui-tooltip-popovers.js"
  ];
  private internalCSSs: string[] = [
    "assets/plugins/dropzone/dropzone.min.css",
    "assets/css/accounting-dashboard/style.css",
    "assets/plugins/charts/c3charts/c3.min.css",
    "assets/css/classic-dashboard/style.css",
    "assets/plugins/table/datatable/datatables.css",
    "assets/plugins/table/datatable/custom_dt_multiple_tables.css",
    "assets/plugins/animate/animate.css",
    "assets/plugins/loaders/csspin.css",
    "assets/plugins/loaders/custom-loader.css",
    "assets/plugins/maps/vector/jvector/jquery-jvectormap-2.0.3.css",
    "assets/plugins/charts/chartist/chartist.css",
    "assets/css/default-dashboard/style.css",
    "assets/css/miscellaneous.css",
    "assets/css/custom-tabs.css",
    "assets/plugins/font-icons/fontawesome/css/regular.css",
    "assets/plugins/font-icons/fontawesome/css/solid.css",
    "assets/plugins/font-icons/fontawesome/css/brands.css",
    "assets/plugins/font-icons/fontawesome/css/fontawesome.css",
    "assets/css/custom-tooltips_and_popovers.css",
    "assets/css/ui-kit/tabs-accordian/custom-accordions.css",
    "assets/css/notification/notify-metro.css",
    "assets/css/notification/jquery.growl.css",
    "assets/plugins/fullcalendar/fullcalendar.css",
    "assets/plugins/fullcalendar/fullcalendar-basic.css",
    "assets/plugins/todo-list/moderntodo/mod-todo.css",
    "assets/css/ui-kit/mailing-chat.css",
    "assets/css/search-multiple.css",
    "assets/css/notification/tympanus/demo.css",
    "assets/plugins/maps/jquerymapael/advanced/custom-mapael_advanced_style.css",
    "assets/css/landing/cloud-bundle.min.css",
    "assets/css/notification/tympanus/ns-style-other.css",
    "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
    
  ];
  private lateInternalCSSs: string[] = [
    "assets/css/stock-market-dashboard/style.css",
    "assets/css/notification/tympanus/demo.css",
    "assets/css/notification/tympanus/ns-default.css",
    "assets/css/notification/tympanus/ns-style-growl.css",
    "assets/css/notification/tympanus/ns-style-attached.css",
    "assets/css/notification/tympanus/ns-style-other.css"
  ]

  constructor(private router: Router) {}

  /**
   * Charge un script dynamiquement en évitant les doublons et les routes exclues.
   */
  public loadScripts(): void {
    for(var url of this.internalScripts){
      this.loadUnit(url);
    }
    setTimeout(()=>{
      for(var url of this.lateInternalScripts){
        this.loadUnit(url);
      }
    }, 2000);
  }
  public loadCSSs(): void {
    console.log(document.location.href);
    
    if (this.excludedRoutes.includes(this.router.url) || document.location.href.indexOf("/index")>-1) {
      console.log(`Script non chargé sur la route exclue: ${this.router.url}`);
      return;
    }
    for(var url of this.internalCSSs){
      let node = document.createElement("link");
      node.href = url;
      node.type = "text/javascript";
      node.id = "css_landing";
      node.rel ="stylesheet";
      var linksTags = document.getElementsByTagName('link');
      for (var i = linksTags.length; i--;) {
          if (linksTags[i].href != url) {
            document.getElementsByTagName("head")[0].appendChild(node);
            // break;
          }else {
            break;
          }
      }
    }
    setTimeout(()=>{
      for(var url of this.lateInternalCSSs){
        let node = document.createElement("link");
        node.href = url;
        node.type = "text/javascript";
        node.id = "css_landing";
        node.rel ="stylesheet";
        var linksTags = document.getElementsByTagName('link');
        for (var i = linksTags.length; i--;) {
            if (linksTags[i].href != url) {
              document.getElementsByTagName("head")[0].appendChild(node);
              // break;
            }else {
              break;
            }
        }
      }
    }, 2000);
  }
  public loadUnit(url:string) {
      // Vérifier si l'on est sur une page exclue
      if (this.excludedRoutes.includes(this.router.url) || document.location.href.indexOf("/index")>-1) {
        console.log(`Script non chargé sur la route exclue: ${this.router.url}`);
        return;
      }

      // Vérifier si le script est déjà chargé
      const scripts = document.getElementsByTagName('script');
      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.includes(url)) {
          console.log(`Script déjà chargé: ${url}`);
          return;
        }
      }

      // Ajouter dynamiquement le script
      const script = document.createElement('script');
      script.src = url;
      script.type = 'text/javascript';
      script.async = true;
      document.body.appendChild(script);

      console.log(`Script chargé: ${url}`);
  }
}
